export const NOTIFY_CHANGED_ACTION = 'NOTIFY_CHANGED_ACTION';
export const NOTIFY_BATCH_CHANGED_ACTION = 'NOTIFY_BATCH_CHANGED_ACTION';
export const NOTIFY_REMOVED_ACTION = 'NOTIFY_REMOVED_ACTION';
export const NOTIFY_ADDED_ACTION = 'NOTIFY_ADDED_ACTION';
export const NOTIFY_BATCH_ADDED_ACTION = 'NOTIFY_BATCH_ADDED_ACTION';
export const NOTIFY_BATCH_REMOVED_ACTION = 'NOTIFY_BATCH_REMOVED_ACTION';
export const NOTIFY_NOTIFY_ACTION = 'NOTIFY_NOTIFY_ACTION';
